import { render } from "./MenOfTheMarauders.vue?vue&type=template&id=97a8b25c"
import script from "./MenOfTheMarauders.vue?vue&type=script&lang=ts"
export * from "./MenOfTheMarauders.vue?vue&type=script&lang=ts"
script.render = render

export default script